import React from 'react';
import PropTypes from "prop-types";
import ReactDOM from 'react-dom';
import Footer from './footer.jsx';
import Header from './header.jsx';
import PlusMinus from './plusMinus.jsx';
import BotLevel from './botLevel.jsx';

class StartBotGame extends React.Component {

    constructor() {
        super();

        this.state = {
            numBots: 1,
            botLevel: 2,
        }
    }

    setNumBots(num) {

        if (num < 1)
            num = 1;
        if (num > 7)
            num = 7;

        this.setState({
            numBots: num
        });
    }

    setBotLevel(num) {

        if (num < 1)
            num = 1;
        if (num > 5)
            num = 5;

        this.setState({
            botLevel: num
        });
    }

    genOpenSlots() {
        var slot = this.state.numBots == 3 ? "slot" : "slots";

        if (this.state.numBots == 4)
            return "Other players are less likely to join this game through matchmaking";
        else if (this.state.numBots < 5)
            return "Other players can find and join this game through matchmaking";
        else
            return "Other players will need an invite link to join";
    }

    clickStart() {
        this.props.clickStart(this.state.numBots, this.state.botLevel);
    }

	render() {

        return (
            <div class="main" id="main">
                <canvas id="backCanvas" class="backCanvas"></canvas>
                <Header name="Game VS Bots" clickBack={this.props.clickBack}/>

                <div class="middle" id="search">
                    <br/><br/>
                    Num bots: <PlusMinus value={this.state.numBots} setValue={this.setNumBots.bind(this)}/> <br/><br/>
                    Bot Level: <BotLevel value={this.state.botLevel} setValue={this.setBotLevel.bind(this)}/> <br/><br/><br/>

                    <button onClick={this.clickStart.bind(this)} id="go">Start Game</button><br/><br/><br/>
                    { this.genOpenSlots() }
                </div>

                <Footer />
            </div>
        );
	}
}

StartBotGame.propTypes = {
  clickBack: PropTypes.func,
  clickStart: PropTypes.func,
};

export default StartBotGame;